import React from 'react';
import { Master } from "@Routes"
import { SnackbarProvider } from "notistack";


function App() {
  return (
    <SnackbarProvider>
      <Master />
    </SnackbarProvider>

  );
}

export default App;
